"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* `preprocessor` and `testContent` are normally replaced by inline literals while bundling an app's JS.
 *
 * If these values have not been set we want to provide defaults however
 * attempting to access them can trigger a ReferenceError as the
 * variables are undefined (distinct from a defined variable being set to
 * `undefined`).
 *
 * `typeof` checks can safely test undefined variables, note that these checks will become:
 * `typeof { DEBUG_BUILD: true, ... }` when webpack's DefinePlugin is used in @jet/build's webpack task.
 * When these variables have not been replaced we need to use `globalThis` to set them on the global scope
 * in order to avoid ReferenceErrors attempting to access them.
 */
if (typeof preprocessor === "undefined") {
    globalThis.preprocessor = {
        PRODUCTION_BUILD: false,
        CARRY_BUILD: false,
        DEBUG_BUILD: false,
        INTERNAL_BUILD: false,
    };
}
if (typeof testContent === "undefined") {
    globalThis.testContent = {
        INCLUDE_TEST_CONTENT: false,
    };
}
__exportStar(require("./bag"), exports);
__exportStar(require("./bundle"), exports);
__exportStar(require("./cookie-provider"), exports);
__exportStar(require("./cryptography"), exports);
__exportStar(require("./host"), exports);
__exportStar(require("./jscookie"), exports);
__exportStar(require("./net"), exports);
__exportStar(require("./platform"), exports);
__exportStar(require("./plist"), exports);
__exportStar(require("./preprocessor"), exports);
__exportStar(require("./random"), exports);
__exportStar(require("./service"), exports);
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map